import type {
  Action,
  ActionActionItemUnion,
  Click,
  ExternalNavigation,
  InternalNavigation,
  Pages,
} from "~/core";
import { ROOM_URL_TEMPLATES } from "~/shared/utils/parse-url-template-and-build-href";

export const isExternalLink = (
  action: ActionActionItemUnion | null | undefined,
): action is ExternalNavigation => {
  return "href" in (action ?? {});
};
export const isInternalLink = (
  action: ActionActionItemUnion | null | undefined,
): action is InternalNavigation => {
  return "page" in (action ?? {});
};
export const isClickAction = (
  action: ActionActionItemUnion | null | undefined,
): action is Click => {
  return "type" in (action ?? {});
};

export const isTemplateUrl = (action: ExternalNavigation): boolean => {
  return !!action?.href?.includes(ROOM_URL_TEMPLATES.ROOM_URL);
};

type GetControlActionParamsInput = {
  controlAction: Action | undefined | null;
  isActionInactive: (control: Action) => boolean;
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
};

type GetLinkPropsFromActionOutput = {
  isInactive: boolean;
  href: string | undefined;
  handlePress: () => void;
};

export const getLinkPropsFromAction = ({
  controlAction,
  isActionInactive,
  getUrl,
  onCallAction,
}: GetControlActionParamsInput): GetLinkPropsFromActionOutput => {
  const action = controlAction?.action?.[0];

  const isInactive = controlAction ? isActionInactive(controlAction) : true;

  let href: string | undefined;

  if (isExternalLink(action?.item)) {
    if (isTemplateUrl(action?.item)) {
      href = undefined;
    } else {
      href = action.item.href ?? undefined;
    }
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }

  const handlePress = (): void => {
    if (controlAction) {
      onCallAction(controlAction);
    }
  };

  return { isInactive, href, handlePress };
};
